import { combineReducers } from 'redux';

import ids from './ids';

/**
 * @typedef {{
 *  ids: import('./ids').State
 * }} NotificationUIDropdownReducer
 */

export default combineReducers({
  ids,
});
